let paypalScriptInserted = false;

const insertPaypalScript = (clientId) => {
  const paypalScript = document.createElement("script");
  paypalScript.setAttribute(
    "src",
    `https://www.paypal.com/sdk/js?client-id=${clientId}&components=messages,buttons`
  );
  paypalScript.setAttribute("data-namespace", "PayPalSDK");
  document.head.appendChild(paypalScript);
};

export const eventuallyInsertPaypalScript = async (clientId) => {
  if (!paypalScriptInserted) {
    paypalScriptInserted = true;
    insertPaypalScript(clientId);
  }
};
